module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "grid h100",
    staticStyle: {
      "grid-template-columns": "auto 1fr auto",
      "grid-template-rows": "auto auto"
    }
  }, [_c('navbar', {
    attrs: {
      "hotel": _vm.hotel,
      "settings": _vm.settings,
      "ombrelli": _vm.ombrelli,
      "addombrid": _vm.addombrid,
      "addombrell": _vm.addombrell,
      "editCanvas": _vm.editCanvas,
      "edit": _vm.edit,
      "getOmbrelli": _vm.getOmbrelli
    }
  }), _vm._v(" "), _c('div', {
    ref: "canvas",
    staticStyle: {
      "display": "grid",
      "justify-items": "center",
      "align-content": "start",
      "overflow": "auto",
      "height": "100vh",
      "padding": "0px"
    }
  }, [_c('div', [_c('p', [(!_vm.edit) ? _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Pick a day",
      "picker-options": _vm.datePickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.changeDate()
      }
    },
    model: {
      value: (_vm.today),
      callback: function($$v) {
        _vm.today = $$v
      },
      expression: "today"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "h100",
    staticStyle: {
      "position": "relative"
    },
    style: ({
      width: _vm.windowWidth + 'px',
      height: _vm.windowHeight + 'px'
    })
  }, _vm._l((_vm.ombrelli), function(ombrello, index) {
    return _c('VueDragResize', {
      key: ombrello._id,
      staticClass: "grid ombrello",
      attrs: {
        "preventActiveBehavior": true,
        "parentW": _vm.windowWidth,
        "parentH": _vm.windowHeight,
        "parentLimitation": true,
        "isActive": _vm.edit,
        "x": ombrello.x,
        "y": ombrello.y,
        "w": ombrello.width,
        "h": ombrello.height,
        "isDraggable": _vm.edit,
        "isResizable": false
      },
      on: {
        "clicked": function($event) {
          _vm.edit ? _vm.noshow() : _vm.show(ombrello)
        },
        "resizing": _vm.resize,
        "dragstop": function (left, top, width, height) { return _vm.onResizing(index, left, top, width, height); }
      }
    }, [(!ombrello.free) ? _c('div', {
      staticClass: "grid seat",
      class: {
        minimal: !_vm.hotel.poolsettings.chairs || !_vm.hotel.poolsettings.beds
      },
      on: {
        "click": function($event) {
          _vm.edit ? _vm.noshow() : _vm.show(ombrello)
        }
      }
    }, [(_vm.edit) ? _c('span', {
      staticClass: "deleteombrello"
    }, [_c('i', {
      staticClass: "fas fa-trash",
      on: {
        "click": function($event) {
          return _vm.deleteOmbrello(index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "grid header",
      class: {
        single: !_vm.hotel.poolsettings.chairs || !_vm.hotel.poolsettings.beds, hidden: !_vm.hotel.poolsettings.chairs && !_vm.hotel.poolsettings.beds
      }
    }, [(_vm.hotel.poolsettings.beds) ? _c('img', {
      attrs: {
        "src": require("../assets/img/beach-deckchair-.png")
      }
    }) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.chairs) ? _c('img', {
      attrs: {
        "src": require("../assets/img/beach-chair.png")
      }
    }) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.chairs) ? _c('span', {
      staticClass: "grid"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removechair(index, ombrello.chairs, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus-square"
    })]), _vm._v(_vm._s(ombrello.chairs)), _c('a', {
      on: {
        "click": function($event) {
          return _vm.addchair(index, ombrello.chairs, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-plus-square"
    })])]) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.beds) ? _c('span', {
      staticClass: "grid"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removebed(index, ombrello.beds, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus-square"
    })]), _vm._v(_vm._s(ombrello.beds)), _c('a', {
      on: {
        "click": function($event) {
          return _vm.addbed(index, ombrello.beds, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-plus-square"
    })])]) : _vm._e()]), _vm._v(" "), (!_vm.hotel.poolsettings.guest && !_vm.hotel.poolsettings.room) ? _c('el-popover', {
      attrs: {
        "placement": "top-start",
        "title": 'Dettagli ombrello ' + ombrello.ombrid,
        "width": "auto",
        "trigger": "hover",
        "fit": "true",
        "content": ombrello.guestsinday[0].name
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": ombrello.guestsinday
      }
    }, [_c('el-table-column', {
      attrs: {
        "width": "auto",
        "property": "room",
        "label": "Stanza"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "min-width": 100,
        "property": "name",
        "label": "Nome"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "120",
        "property": "arrival",
        "label": "Arrivo"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "120",
        "property": "departure",
        "label": "Partenza"
      }
    })], 1), _vm._v(" "), _c('el-button', {
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "fas fa-info-circle"
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.room || _vm.hotel.poolsettings.guest) ? _c('div', {
      staticClass: "grid ident"
    }, [(_vm.hotel.poolsettings.room) ? _c('span', {
      staticClass: "room"
    }, [_vm._v(_vm._s(ombrello.guestsinday[0].room))]) : _vm._e(), _vm._v(" "), (ombrello.guest && _vm.hotel.poolsettings.guest) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.guestsinday[0].name))]) : _vm._e(), _vm._v(" "), (!ombrello.guest && _vm.hotel.poolsettings.guest) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v("no guest name")]) : _vm._e(), _vm._v(" "), (ombrello.guestsinday.length > 1) ? _c('span', {
      staticClass: "room"
    }, [_vm._v(_vm._s(ombrello.guestsinday[1].room))]) : _vm._e(), _vm._v(" "), (ombrello.guest && ombrello.guestsinday.length > 1) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.guestsinday[1].name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "grid data",
      class: {
        minimal: !_vm.hotel.poolsettings.chairs || !_vm.hotel.poolsettings.beds, hidden: !_vm.hotel.poolsettings.arrival
      }
    }, [_c('div', {
      staticClass: "grid nr"
    }, [_vm._v(_vm._s(ombrello.ombrid))]), _vm._v(" "), (_vm.hotel.poolsettings.arrival || _vm.hotel.poolsettings.departure) ? _c('div', {
      staticClass: "grid date",
      class: {
        hidden: !_vm.hotel.poolsettings.arrival
      }
    }, [_c('span', [_c('span', {
      staticClass: "fa fa-chevron-right"
    }), _vm._v(" " + _vm._s(ombrello.arrival))]), _vm._v(" "), _c('span', [_c('span', {
      staticClass: "fa fa-chevron-left"
    }), _vm._v(" " + _vm._s(ombrello.departure))])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (ombrello.free && ombrello.location === 'canvas') ? _c('div', {
      staticClass: "grid seat free drop",
      attrs: {
        "id": ombrello._id
      },
      on: {
        "click": function($event) {
          _vm.edit ? _vm.noshow() : _vm.show(ombrello)
        }
      }
    }, [(_vm.edit) ? _c('span', {
      staticClass: "deleteombrello"
    }, [_c('i', {
      staticClass: "fas fa-trash",
      on: {
        "click": function($event) {
          return _vm.deleteOmbrello(index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "grid nr",
      attrs: {
        "id": ombrello._id
      }
    }, [_vm._v(_vm._s(ombrello.ombrid))])]) : _vm._e()])
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "grid overview"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nome ospite o numero camera"
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  }), _vm._v(" "), (_vm.overview.arrivals.length > 0) ? _c('h2', [_vm._v("Check In")]) : _vm._e(), _vm._v(" "), (_vm.overview.arrivals.length > 0) ? _c('div', {
    staticClass: "grid arrivals"
  }, _vm._l((_vm.filteredArrivals), function(arrival) {
    return _c('span', {
      staticClass: "arrival"
    }, [_vm._v(_vm._s(arrival.ombrid) + " - " + _vm._s(arrival.guest.name) + "@" + _vm._s(arrival.guest.room))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.overview.departures.length > 0) ? _c('h2', [_vm._v("Check Out")]) : _vm._e(), _vm._v(" "), (_vm.overview.departures.length > 0) ? _c('div', {
    staticClass: "grid departures"
  }, _vm._l((_vm.filteredDepartures), function(departure) {
    return _c('span', {
      staticClass: "departure"
    }, [_vm._v(_vm._s(departure.ombrid) + " - " + _vm._s(departure.guest.name) + "@" + _vm._s(departure.guest.room))])
  }), 0) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "grid stays"
  }, _vm._l((_vm.filteredStays), function(stay) {
    return _c('span', {
      staticClass: "stay"
    }, [_vm._v(_vm._s(stay.ombrid) + " - " + _vm._s(stay.guest.name) + "@" + _vm._s(stay.guest.room))])
  }), 0)], 1), _vm._v(" "), _c('Hello', {
    attrs: {
      "ombrellos": _vm.ombrellos,
      "hotel": _vm.hotel,
      "disabledDates": _vm.disabledDates,
      "range": _vm.range
    },
    on: {
      "changeOmbrellodate": _vm.onChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22e239df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Canvas.vue
// module id = 624
// module chunks = 1